import React, { useEffect } from 'react';

import AppStylesProvider from 'components/bs4-theme-provider';
import RoleplayUsageManagement, { RoleplayUsageVariant } from 'roleplay/course-level-management/roleplay-usage-management';
import useRoleplayUsageForm, { RoleplayUsageValue } from 'roleplay/course-level-management/use-roleplay-usage-form';

type CourseFormRoleplayUsageProps = {
  initialValue: RoleplayUsageValue,
  readOnly?: boolean,
  // Reports changes back to courseDraft; saved on full-form submit.
  onValueChange: (value: RoleplayUsageValue) => void,
  // Exposes validate() to the controller to block save on 0 types.
  registerValidate?: (validate: () => boolean) => void,
};

const CourseFormRoleplayUsage = (props: CourseFormRoleplayUsageProps) => {
  const {
    initialValue,
    readOnly = false,
    onValueChange,
    registerValidate,
  } = props;

  const { value, onChange, validate, error } = useRoleplayUsageForm(initialValue);

  useEffect(() => {
    registerValidate?.(validate);
  }, [registerValidate, validate]);

  const handleChange = (newValue: RoleplayUsageValue) => {
    onChange(newValue);
    onValueChange(newValue);
  };

  return (
    <AppStylesProvider>
      <RoleplayUsageManagement
        value={value}
        onChange={handleChange}
        error={error}
        readOnly={readOnly}
        variant={RoleplayUsageVariant.COURSE_BASICS}
      />
    </AppStylesProvider>
  );
};

export default CourseFormRoleplayUsage;
